import { render, staticRenderFns } from "./NotificationsModals.vue?vue&type=template&id=607e215b"
import script from "./NotificationsModals.vue?vue&type=script&lang=js"
export * from "./NotificationsModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports